import { WaveStatus } from "./types.js";
export function isWaveArchived(wave) {
    return wave.status === WaveStatus.Archived;
}
export function activeWaves(waves) {
    return waves.filter((w) => !isWaveArchived(w));
}
export function archivedWaves(waves) {
    return waves.filter(isWaveArchived);
}
/** Deduped archived waves from space + shared lists, most recently updated first. */
export function mergedArchivedWaves(...groups) {
    const seen = new Set();
    const out = [];
    for (const group of groups) {
        for (const wave of group) {
            if (!isWaveArchived(wave) || seen.has(wave.waveId))
                continue;
            seen.add(wave.waveId);
            out.push(wave);
        }
    }
    return out.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
}
